import { Component } from '@angular/core';

@Component({
    templateUrl: './accessdenied.component.html',
    selector: "app-access-denied"
})
export class AccessdeniedComponent { }